import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { Tabs } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import { Overview } from './tabContent/Overview'
import { RegularContentTab } from './tabContent/RegularContentTab'
import { Thread } from '../../../../components/blocks/thread/Thread'
import { useParamState } from '@app/util/hooks/useParamState'
import { ViewPlotModel } from 'functions/app/plot/view'

const tabs = {
  overview: 'overview',
  application: 'application',
  documents: 'documents',
  thread: 'thread',
} as const
type Tabs = keyof typeof tabs

export const TabContent = ({ plot }: { plot: ViewPlotModel }) => {
  const translations = useTranslations().app.plotPage
  const [tab, setTab] = useParamState(tabs, tabs.overview)
  const applicationTabSections =
    plot.contentBlocks?.filter(
      (c: { type: string; $position: string }) =>
        c.$position === 'applicationTab',
    ) ?? []
  const documentsTabSections =
    plot.contentBlocks?.filter(
      (c: { type: string; $position: string }) =>
        c.$position === 'documentsTab',
    ) ?? []
  return (
    <Column alignItems="stretch" gap="2rem">
      <Tabs.Group selectedTab={tab}>
        <Tabs.Tab
          label={translations.overview}
          tabKey={tabs.overview}
          onSelectTab={setTab}
        />
        {plot.byCrowdbuilding && (
          <Tabs.Tab
            label={translations.applicationProcedure}
            tabKey={tabs.application}
            onSelectTab={setTab}
          />
        )}
        {plot.byCrowdbuilding && (
          <Tabs.Tab
            label={translations.documents}
            tabKey={tabs.documents}
            onSelectTab={setTab}
          />
        )}
        <Tabs.Tab
          label={translations.thread}
          tabKey={tabs.thread}
          onSelectTab={setTab}
        />
      </Tabs.Group>
      {match(tab)
        .with(tabs.overview, () => <Overview key="overview" plot={plot} />)
        .with(tabs.application, () => (
          <RegularContentTab
            key="application"
            sections={applicationTabSections}
          />
        ))
        .with(tabs.documents, () => (
          <RegularContentTab key="documents" sections={documentsTabSections} />
        ))
        .with(tabs.thread, () => (
          plot.thread?.id ? (
            <Thread key="thread" threadId={plot.thread.id} />
          ) : null
        ))
        .exhaustive()}
    </Column>
  )
}
